/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllingWageEntries } from '../models/ControllingWageEntries';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControllingWageEntriesService {
    /**
     * lists wage entries of project
     * @param tenantId tenant_id
     * @param projectId project_id
     * @param overheads overheads
     * @param startDate start_date
     * @param endDate end_date
     * @param costObjectNumbersArray cost object numbers
     * @returns ControllingWageEntries calls service with commuting: true if overheads is overheads
     * @throws ApiError
     */
    public static getWageEntries(
        tenantId: string,
        projectId: string,
        overheads: boolean,
        startDate?: string,
        endDate?: string,
        costObjectNumbersArray?: Array<string>,
    ): CancelablePromise<ControllingWageEntries> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/{project_id}/wage_entries',
            path: {
                'tenant_id': tenantId,
                'project_id': projectId,
            },
            query: {
                'overheads': overheads,
                'start_date': startDate,
                'end_date': endDate,
                'cost_object_numbers[]': costObjectNumbersArray,
            },
            errors: {
                404: `project not found`,
            },
        });
    }
}
